import { ProjectsSection } from '@src/components/layout/admin/sections/projects';

export default function ProjectPage() {
    return <ProjectsSection title="โครงการทั้งหมด" />;
}
